import { render, staticRenderFns } from "./previousLabels.vue?vue&type=template&id=cb99a934"
import script from "./previousLabels.vue?vue&type=script&lang=js"
export * from "./previousLabels.vue?vue&type=script&lang=js"
import style0 from "./previousLabels.vue?vue&type=style&index=0&id=cb99a934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports